/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
// eslint-disable-next-line jsx-a11y/no-static-element-interactions
import React from 'react';
import { styled } from '@mui/system';
import MenuBar from './MenuBar';
import { MENU_BAR } from './constants';
import { pr } from '@/utils/pxToRem';
import { style } from '@/styles/globals';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import { useRouter } from 'next/router';

const WrapperHeader = styled('div')`
  background-color: ${style.color.white4};
  width: 100%;
  padding:1em;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.06);
`;

const Header = () => {
  const { push } = useRouter();
  return (
    <Stack sx={{
      background: style.color.white4,
      width: '100%',
      height: '140px',
    }}
    >
      <div
        onClick={() => {
          push('/flight');
        }}
        style={{
          height: 82,
          zIndex: 20,
          position: 'fixed',
          width: '100%',
        }}
      >
        <WrapperHeader>
          <img
            src={process.env.NEXT_PUBLIC_LOGO_LINK}
            alt="logo"
            className="lazyload"
            style={{
              height: pr`50px`,
            }}
          />
        </WrapperHeader>
      </div>
      {/* <Headroom
        style={{
          zIndex: 50,
        }}
      > */}
      <Box sx={{
        zIndex: 10,
        position: 'fixed',
        width: '100%',
        mt: '82px',
      }}
      >
        <MenuBar
          data={MENU_BAR}
        />

      </Box>

      {/* </Headroom> */}

    </Stack>
  );
};

export default Header;
